// COI (Certificate of Insurance) service. Thin wrappers over /api/coi/*.
// Pattern mirrors services/lpr.service.js.

import { api } from '@/lib/api.js';

export function listHolders(accountId) {
  return api.get(`/api/coi/accounts/${encodeURIComponent(accountId)}/holders`);
}

export function getHolder(id) {
  return api.get(`/api/coi/holders/${encodeURIComponent(id)}`);
}

export function createHolder(holder) {
  return api.post('/api/coi/holders', holder);
}

export function updateHolder(id, updates) {
  return api.patch(`/api/coi/holders/${encodeURIComponent(id)}`, updates);
}

export function deactivateHolder(id) {
  return api.post(`/api/coi/holders/${encodeURIComponent(id)}/deactivate`);
}

export function getDealPrefill(dealId) {
  return api.get(`/api/coi/deals/${encodeURIComponent(dealId)}/prefill`);
}

export function listCertificates(dealId) {
  return api.get(`/api/coi/deals/${encodeURIComponent(dealId)}/certificates`);
}

export function getCertificate(id) {
  return api.get(`/api/coi/certificates/${encodeURIComponent(id)}`);
}

export function issueCertificate(body) {
  return api.post('/api/coi/certificates/issue', body);
}

export function sendCertificate(id, body) {
  return api.post(`/api/coi/certificates/${encodeURIComponent(id)}/send`, body);
}

export async function previewCoiPdf(body) {
  const token = localStorage.getItem('tracon_token');
  const res = await fetch('/api/coi/certificates/preview', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const b = await res.json().catch(() => ({}));
    if (res.status === 401) window.dispatchEvent(new Event('auth:expired'));
    throw new Error(b?.error || `preview ${res.status}`);
  }
  return res.blob();
}
